export const simpleScheduleSelector = (state) => state.simpleSchedule.schedule;
export const isLoadingSelector = (state) => state.simpleSchedule.loading;
export const markersSelector = (state) => state.simpleSchedule.markers;